import { api } from "..";

export interface SetRiskScopeBody {
  target: "league" | "country";
  id: number;
  watched: boolean;
}

export const setRiskScope = async (body: SetRiskScopeBody): Promise<void> => {
  await api.client.put("/risk/scope", body);
};
